import * as yup from 'yup';

export const FileExportSchema = yup.object({
	exportStartDate: yup.string().required(),
	exportEndDate: yup.string().required(),
});

export type FileExportSchemaType = yup.InferType<typeof FileExportSchema>;
